interface Values {
  x_payment_method: string;
  x_city: string;
  x_address: string;
  address2?: string;
  x_zip: string;
  x_state: string;
  x_country: string;
  email: string;
  iconType?: string;
  x_card_num?: string;
  x_card_code?: string;
  x_exp_date?: string;
  choldername?: string;
  routing_number?: string;
  account_number?: string;
  bankName?: string;
  bank?: string;
}

export interface Payload {
  lead_id: string;
  cluster_id: string;
  agent: string;
  balance: number;
  lead_owner: string;
  x_payment_method: string;
  city: string;
  address1: string;
  address2?: string;
  zipcode: string;
  state: string;
  country: string;
  first_name: string;
  last_name: string;
  accountid: string;
  amount: string | number;
  email: string;
  amount_type: string;
  use_old_card: string;
  card_type?: string;
  old_cardnumber?: string;
  old_cvv?: string;
  old_expiry?: string;
  old_4digit?: string;
  old_type?: string;
  old_zip?: string;
  cvv?: string;
  cexpiry?: string;
  ccardnumber?: string;
  choldername?: string;
  description: string;
  payment_note:string;
  customer_device: string;
  timezone?: string;
  customer_timezone?: string;
  aholdername?: string;
  routing_number?: string;
  account_number?: string;
  bank_name?: string;
  bank_address?: string;
  cc_token?: string;
  cc_token2?: string;
  stripe_token?: string;
  order_id?: string | null;
  isRetry?: boolean;
  updateMethod?: boolean;
  isInvoice?: boolean | false;
  clientInvoiceId?: string | "";
  isScheduleOnetime?: boolean | false;
  schedule_id?: any | 0;
  isrecurring?: string;
  cppid?: number | 0;
  pc_atid?: number | 0;
  phone_number?: any;
  amountfield?: any;
  percentagefield?: any;
  datefield?: any;
  __abortSignal?: AbortSignal;
  custom_conv?:string
  offer_type?: string;
  vdc_id?: number;
}

export type OfferLinkage = {
  offer_type: string;
  vdc_id: number;
};

export const resolveOfferLinkage = (
  offerType: unknown,
  vdcId: unknown
): Partial<OfferLinkage> => {
  const normalizedOfferType = String(offerType ?? "").trim();
  const normalizedVdcId = Number(vdcId);

  if (
    !normalizedOfferType ||
    !Number.isInteger(normalizedVdcId) ||
    normalizedVdcId <= 0
  ) {
    return {};
  }

  return {
    offer_type: normalizedOfferType,
    vdc_id: normalizedVdcId,
  };
};

export interface PaymentOffer {
  id: number;
  offer_type: string;
  headline: string;
  description: string;
  settlement_offer: string;
  settlement_amount: number;
  frequency_type: string;
  no_of_transactions: number;
  payment_frequency: string;
  clusterid: number;
  sort_order: number;
  modify_schedule: string;
  apply_condition: string;
  offerset_id: number;
  mio_formula: any;
  mio_months_field: any;
  mio_discount_limit: any;
}

export interface PaymentOfferResponse {
  status: number;
  body: {
    success: boolean;
    data: PaymentOffer[];
  };
}
